import { call, put, takeEvery } from 'redux-saga/effects'
import * as balanceOfdebtActions from '../ducks/balanceOfdebtDucks'
import * as balanceOfdebtApi from '../../api/balanceOfdebtApi'

interface FetchBalanceOfdebtListSaga {
  type: string
  payload: string
}

interface FetchBalanceOfdebtDetailSaga {
  type: string
  payload: string
}

function* fetchListBalanceOfdebt({ payload: queryString }: FetchBalanceOfdebtListSaga) {
  try {
    const res: ReturnType<typeof balanceOfdebtApi.getListBalanceOfdebt> = yield call(balanceOfdebtApi.getListBalanceOfdebt, queryString)
    yield put(balanceOfdebtActions.getListBalanceOfdebtSuccess(res))
  } catch (error) {
    yield put(balanceOfdebtActions.getListBalanceOfdebtFail(error))
  }
}

function* fetchDetailBalanceOfdebt({ payload: id }: FetchBalanceOfdebtDetailSaga) {
  try {
    const res: ReturnType<typeof balanceOfdebtApi.getDetailBalanceOfdebt> = yield call(balanceOfdebtApi.getDetailBalanceOfdebt, id)
    yield put(balanceOfdebtActions.getDetailBalanceOfdebtSuccess(res))
  } catch (error) {
    yield put(balanceOfdebtActions.getDetailBalanceOfdebtFail(error))
  }
}


export default function* watchSupplier() {
  yield takeEvery(balanceOfdebtActions.getListBalanceOfdebt.toString(), fetchListBalanceOfdebt)
  yield takeEvery(balanceOfdebtActions.getDetailBalanceOfdebt.toString(), fetchDetailBalanceOfdebt)
}
